// modules/vertical-feature-slider.js

/**
 * Vertical Feature Slider
 * - Su desktop (>= 992px): immagini sincronizzate, hover e autoplay.
 * - Su mobile/tablet piccoli: resta testuale, ma il tap aggiorna lo stato attivo.
 */

export function initVerticalFeatureSlider() {

    const sliders = document.querySelectorAll("[data-vertical-slider]");
    if (!sliders.length) {
        console.warn("[vertical-feature-slider] Nessuno slider trovato nella pagina.");
        return;
    }

    console.log(`[vertical-feature-slider] Inizializzazione di ${sliders.length} slider/sezioni.`);

    const mqDesktop = window.matchMedia("(min-width: 992px)");
    const mqReduced = window.matchMedia("(prefers-reduced-motion: reduce)");

    sliders.forEach((slider, index) => {
        const items = slider.querySelectorAll("[data-vfs-index]");
        const images = slider.querySelectorAll("[data-vfs-image-index]");

        if (!items.length || !images.length) {
            console.warn(`[vertical-feature-slider] Slider #${index + 1}: struttura incompleta (items: ${items.length}, images: ${images.length}).`);
            return;
        }

        let current = Array.from(items).findIndex((item) => item.classList.contains("is-active"));
        if (current < 0) current = 0;

        let interval = null;
        let itemEventsBound = false;
        let desktopEventsBound = false;
        const delay = parseInt(slider.getAttribute("data-vfs-delay"), 10) || 5000;

        const pagination = slider.querySelector("[data-vertical-slider-bullets]");
        let dots = [];

        /**
         * Attiva un blocco e, solo su desktop, l'immagine corrispondente.
         */
        const activate = (indexSel) => {
            items.forEach((btn, i) => {
                const isActive = i === indexSel;
                btn.classList.toggle("is-active", isActive);
                btn.setAttribute("aria-selected", isActive);
                images[i]?.classList.toggle("is-active", mqDesktop.matches && isActive);
            });

            current = indexSel;
            console.log(`[vertical-feature-slider] Slider #${index + 1} -> attiva item ${indexSel + 1}/${items.length}`);

            if (dots.length) {
                dots.forEach((dot, i) => {
                    dot.classList.toggle("is-active", i <= indexSel);
                });
            }
        };

        const startAutoplay = () => {
            clearInterval(interval);

            if (mqReduced.matches || !mqDesktop.matches || delay <= 0) {
                return;
            }

            interval = setInterval(() => {
                const next = (current + 1) % items.length;
                activate(next);
            }, delay);
        };

        /**
         * Interazioni valide su tutti i breakpoint.
         */
        const bindItemEvents = () => {
            if (itemEventsBound) return;

            items.forEach((btn, i) => {
                btn.addEventListener("click", () => activate(i));
                btn.addEventListener("focus", () => activate(i));
                btn.addEventListener("keydown", (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        activate(i);
                    }
                });
            });

            itemEventsBound = true;
        };

        if (pagination) {
            pagination.innerHTML = "";
            items.forEach((_, i) => {
                const dot = document.createElement("span");
                dot.className = "vfs__dot";
                dot.dataset.dotIndex = i;
                dot.addEventListener("click", (e) => {
                    e.stopPropagation();
                    activate(i);
                });
                pagination.appendChild(dot);
                dots.push(dot);
            });
        }

        /**
         * Avvia interazioni e autoplay desktop.
         */
        const setup = () => {
            console.log(`[vertical-feature-slider] Slider #${index + 1} -> setup (desktop >=992px, delay=${delay}ms)`);

            activate(current);

            if (!desktopEventsBound) {
                items.forEach((btn, i) => {
                    btn.addEventListener("mouseenter", () => {
                        if (mqDesktop.matches) activate(i);
                    });
                });

                slider.addEventListener("mouseenter", () => {
                    clearInterval(interval);
                    console.log(`[vertical-feature-slider] Slider #${index + 1} -> autoplay in pausa (hover).`);
                });

                slider.addEventListener("mouseleave", () => {
                    startAutoplay();
                    console.log(`[vertical-feature-slider] Slider #${index + 1} -> autoplay ripreso (mouseleave).`);
                });

                desktopEventsBound = true;
            }

            if (!mqReduced.matches && delay > 0) {
                startAutoplay();
            } else {
                console.warn(`[vertical-feature-slider] Slider #${index + 1} -> autoplay disattivato (reduced-motion o delay=0).`);
            }
        };

        /**
         * Disattiva immagini e autoplay su mobile/tablet piccoli.
         */
        const teardown = () => {
            clearInterval(interval);
            console.log(`[vertical-feature-slider] Slider #${index + 1} -> disattivo (mobile <992px)`);
            images.forEach((img) => img.classList.remove("is-active"));

            if (!slider.querySelector("[data-vfs-index].is-active")) {
                activate(0);
            }
        };

        const handleViewport = (e) => {
            clearInterval(interval);
            if (e.matches) {
                setup();
            } else {
                teardown();
            }
        };

        bindItemEvents();
        handleViewport(mqDesktop);
        mqDesktop.addEventListener("change", handleViewport);

        console.log(`[vertical-feature-slider] Slider #${index + 1} inizializzato (${items.length} blocchi, ${images.length} immagini).`);
    });
}
